import { HoverBubble } from '../Common/Hover'
import { CanvasMiniMap, type CanvasMiniMapItem } from '../DrawingBoard/CanvasMiniMap'
import { VisionboardShelf } from '../DrawingBoard/VisionboardShelf'
import { ClipboardInterceptor } from '../DrawingBoard/ClipboardInterceptor'
import { MarkdownSyncStatus } from '../DrawingBoard/MarkdownSyncStatus'
import type { ChecklistItem } from '../../types/schema'
import type { CanvasViewportState, MarkdownSyncMetadata } from '../../context/TimelineContext'

export interface BoardOverlaysProps {
  checklistHover: { bubbleProps: any }
  collectChecklistAvoidZones: () => DOMRect[]
  isMiniMapVisible: boolean
  miniMapItems: CanvasMiniMapItem[]
  viewportState: CanvasViewportState
  viewportSize: { width: number; height: number }
  boardMetrics: { width: number; height: number }
  handleMiniMapPan: (targetX: number, targetY: number) => void
  canEditStructure: boolean
  isCalendarShelfOpen: boolean
  visionboardChecklistItems: ChecklistItem[]
  setIsCalendarShelfOpen: (isOpen: boolean) => void
  isClipboardWatcherEnabled: boolean
  handleClipboardBlueprintExtract: (clipboardText: string) => Promise<void>
  isMarkdownPanelOpen: boolean
  markdownMetadata: MarkdownSyncMetadata
  displayNodes: ChecklistItem[]
  linkMarkdownRepository: (repoPath: string) => void
  applyMarkdownInboundSync: (markdownPayload: string) => Promise<void> | void
}

export function BoardOverlays({
  checklistHover,
  collectChecklistAvoidZones,
  isMiniMapVisible,
  miniMapItems,
  viewportState,
  viewportSize,
  boardMetrics,
  handleMiniMapPan,
  canEditStructure,
  isCalendarShelfOpen,
  visionboardChecklistItems,
  setIsCalendarShelfOpen,
  isClipboardWatcherEnabled,
  handleClipboardBlueprintExtract,
  isMarkdownPanelOpen,
  markdownMetadata,
  displayNodes,
  linkMarkdownRepository,
  applyMarkdownInboundSync,
}: BoardOverlaysProps) {
  return (
    <>
      <HoverBubble
        {...checklistHover.bubbleProps}
        avoidZoneRects={collectChecklistAvoidZones}
      />
      {isMiniMapVisible && (
        <CanvasMiniMap
          items={miniMapItems}
          viewportState={viewportState}
          viewportSize={{
            width: viewportSize.width,
            height: viewportSize.height,
          }}
          worldSize={{ width: boardMetrics.width, height: boardMetrics.height }}
          onPanToCoordinates={handleMiniMapPan}
        />
      )}
      {canEditStructure && (
        <>
          <VisionboardShelf
            isOpen={isCalendarShelfOpen}
            items={visionboardChecklistItems}
            onClose={() => setIsCalendarShelfOpen(false)}
          />
          <ClipboardInterceptor
            enabled={canEditStructure && isClipboardWatcherEnabled}
            onExtractBlueprint={handleClipboardBlueprintExtract}
          />
        </>
      )}
      {isMarkdownPanelOpen && (
        <MarkdownSyncStatus
          metadata={markdownMetadata}
          nodes={displayNodes}
          onLinkRepo={linkMarkdownRepository}
          onSimulateInboundSync={(markdownPayload) => void applyMarkdownInboundSync(markdownPayload)}
        />
      )}
    </>
  )
}
